import React from "react";
import "../Consultation.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { motion } from "framer-motion";

import {
FaShieldAlt,
FaSearch,
FaUserCheck,
FaClipboardCheck,
FaCloud,
FaNetworkWired,
FaCheckCircle
} from "react-icons/fa";



const Consultation = () => {


    return (

        <>

            <Header />


            <title>
                Cybersecurity Consultation | BlueLotus Infrasafety Projects Private Limited
            </title>




            {/* HERO */}

            <section className="consult-hero">


                <div className="container">


                    <motion.div

                        className="consult-hero-content"

                        initial={{ opacity: 0, y: 40 }}

                        animate={{ opacity: 1, y: 0 }}

                        transition={{ duration: .8 }}

                    >


                        <span>

                            Cybersecurity Consultation

                        </span>


                        <h1>

                            Build A Stronger Security
                            <h1 style={{display:"block", color:"#60a5fa"}}>Strategy For Your Business</h1>

                        </h1>


                        <p>

                            Connect with BlueLotus Infrasafety Projects Private Limited security experts
                            to identify risks, strengthen defenses,
                            and develop a customized cybersecurity roadmap.

                        </p>


                    </motion.div>


                </div>


            </section>









            {/* INTRO */}



            <section className="consult-intro">


                <div className="container">


                    <h2>

                        Expert Guidance For Your Cybersecurity Challenges

                    </h2>


                    <p>

                        Every organization faces unique security challenges.
                        Our cybersecurity consultants analyze your environment,
                        identify vulnerabilities, and recommend practical solutions
                        to improve your overall security posture.

                    </p>


                </div>


            </section>









            {/* FORM SECTION */}


            <section className="consult-section">


                <div className="container consult-grid">





                    {/* BENEFITS */}


                    <div className="consult-info">


                        <h2>

                            Why Choose Cybersecurity Consultation?

                        </h2>


                        <p>

                            Our experts help businesses understand their security
                            risks and create effective protection strategies.

                        </p>





                        <div className="consult-feature">


                            <FaSearch />

                            <div>

                                <h3>

                                    Security Assessment

                                </h3>

                                <p>

                                    Identify vulnerabilities and security gaps.

                                </p>

                            </div>


                        </div>





                        <div className="consult-feature">


                            <FaShieldAlt />

                            <div>

                                <h3>

                                    Risk Protection

                                </h3>

                                <p>

                                    Develop strategies to reduce cyber risks.

                                </p>

                            </div>


                        </div>






                        <div className="consult-feature">


                            <FaShieldAlt />

                            <div>

                                <h3>

                                    Security Roadmap

                                </h3>

                                <p>

                                    Create a long-term cybersecurity plan.

                                </p>

                            </div>


                        </div>



                    </div>










                    {/* FORM */}



                    <div className="consult-form">


                        <h2>

                            Request Consultation

                        </h2>


                        <p>

                            Fill the form and our security team will contact you.

                        </p>



                        <form>


                            <input
                                type="text"
                                placeholder="Full Name"
                            />


                            <input
                                type="email"
                                placeholder="Business Email"
                            />


                            <input
                                type="text"
                                placeholder="Company Name"
                            />


                            <input
                                type="tel"
                                placeholder="Phone Number"
                            />



                            <select>

                                <option>
                                    Select Security Requirement
                                </option>

                                <option>
                                    Network Security
                                </option>

                                <option>
                                    Cloud Security
                                </option>

                                <option>
                                    Vulnerability Assessment
                                </option>

                                <option>
                                    SOC Monitoring
                                </option>

                                <option>
                                    Incident Response
                                </option>

                                <option>
                                    BlueLotus SecureShield
                                </option>

                                <option>
                                    Others
                                </option>

                            </select>




                            <textarea

                                placeholder="Tell us about your security requirements"

                                rows="5"

                            />



                            <button>

                                Schedule Consultation

                            </button>


                        </form>


                    </div>




                </div>


            </section>









            {/* PROCESS */}



            <section className="consult-process">


                <div className="container">


                    <h2>

                        Our Consultation Process

                    </h2>



                    <div className="process-grid">



                        <div>

                            <span>01</span>

                            <h3>
                                Understand
                            </h3>

                            <p>
                                Analyze your business requirements and security challenges.
                            </p>

                        </div>



                        <div>

                            <span>02</span>

                            <h3>
                                Assess
                            </h3>

                            <p>
                                Evaluate risks, vulnerabilities, and current security controls.
                            </p>

                        </div>




                        <div>

                            <span>03</span>

                            <h3>
                                Recommend
                            </h3>

                            <p>
                                Provide customized security recommendations.
                            </p>

                        </div>




                        <div>

                            <span>04</span>

                            <h3>
                                Implement
                            </h3>

                            <p>
                                Support your organization with security improvements.
                            </p>

                        </div>


                    </div>


                </div>


            </section>









            {/* CONSULT AREAS */}



            <section className="consult-areas">


                <div className="container">


                    <h2>

                        Consultation Areas

                    </h2>


                    <div className="area-grid">


                        <div>

                            <FaNetworkWired />

                            <h3>

                                Network Security

                            </h3>

                        </div>



                        <div>

                            <FaCloud />

                            <h3>

                                Cloud Security

                            </h3>

                        </div>



                        <div>

                            <FaUserCheck />

                            <h3>

                                Identity Security

                            </h3>

                        </div>




                        <div>

                            <FaCheckCircle />

                            <h3>

                                Compliance

                            </h3>

                        </div>


                    </div>


                </div>


            </section>








            {/* CTA */}



            <section className="consult-cta">


                <div className="container">


                    <h2>

                        Ready To Strengthen Your Security?

                    </h2>


                    <p>

                        Book a cybersecurity consultation with BlueLotus Infrasafety Projects Private Limited experts today.

                    </p>


                </div>


            </section>





            <Footer />


        </>

    )

}


export default Consultation;